module.exports = __webpack_public_path__ + "img/VT.8a973e47.webp";